/* eslint-disable import/no-anonymous-default-export */
import edigenrwanda from "../../assets/edgenrw.32928356.png";
import barefootNomad from "../../assets/barefootNomad.png";
import votingApp from "../../assets/votingApp.png";

export default [
  {
    title: "Edified Generation",
    link: "https://edigenrwanda.org/",
    image: edigenrwanda,
    description:
      "Together with a small team of engineers, we developed Edified Generation Rwanda platform. We integrated Covid-19 essay writing contest through the app, so that students whose schools stopped due to Corona-Virus pandemic could learn while at home.",
  },
  {
    title: "Online Voting app",
    link: "https://onlinevotingapp.netlify.app/",
    image: votingApp,
    description:
      "I designed and developed the app that can help users to voting between items in a poll, an authenticated user can create a poll or delete a poll and normal users be able to votes on created poll.",
  },
  {
    title: "Barefoot Nomad",
    link: null,
    image: barefootNomad,
    description:
      "Make company global travel and accommodation easy and convenient for the strong workforce of savvy members of staff, by leveraging the modern web.",
  },
];
